module.exports = __webpack_public_path__ + "img/oelsnitz.7fcc6ba0.jpeg";